import { ColumnResizingContextProvider } from 'src/contexts/ColumnResizingContext/ColumnResizingContext';
import { Content } from 'src/contexts/ContentContext';
import { NoData, Table } from 'src/tables/Table';
import { ContentId } from 'src/utils/constants/contentId';
import { UserSetting } from 'src/WebApiController';

import { ReportTableV2Props } from '../ReportTableCommon/ReportTableCommon.types';
import { useReportDetailsTableV2 } from '../ReportTableCommon/useReportDetailsTableV2';
import {
  PurchaseOrderLineItemReportTableColumnDefContextV2,
  usePurchaseOrderLineItemReportTableColumnDefV2,
} from './PurchaseOrderLineItemReportTableColumnDefContextV2';

export const PurchaseOrderLineItemReportTableV2 = ({
  report,
  reportValueTypes,
  ...rest
}: ReportTableV2Props) => {
  return (
    <PurchaseOrderLineItemReportTableColumnDefContextV2
      report={report}
      reportValueTypes={reportValueTypes}
    >
      <ReportTableInternal report={report} {...rest} />
    </PurchaseOrderLineItemReportTableColumnDefContextV2>
  );
};

const ReportTableInternal = (props: ReportTableV2Props) => {
  const { displayedColumnsConfig = [] } =
    usePurchaseOrderLineItemReportTableColumnDefV2();

  const { isReportConfigEmpty, tableProps, data } = useReportDetailsTableV2({
    ...props,
    displayedColumnsConfig,
  });

  return isReportConfigEmpty ? (
    <></>
  ) : data?.length > 0 ? (
    <ColumnResizingContextProvider
      userSettingId={UserSetting.ReportV2PurchaseOrderLineItemColumnWidths}
    >
      <Table {...tableProps} />
    </ColumnResizingContextProvider>
  ) : (
    <NoData>
      <Content id={ContentId.NoReportText} />
    </NoData>
  );
};

export default PurchaseOrderLineItemReportTableV2;
